import { routes } from "@/constants/url";
import { LogoDesktopBlack, ShadowBox } from "@backpac/monica";
import { Helmet } from "react-helmet-async";
import { Outlet } from "react-router";

export function AppAuthLayout() {
  return (
    <>
      <Helmet>
        <title>Login | Backpac</title>
        <meta name="theme-color" content="#fcfaf5" />
      </Helmet>
      <div className="bg-backgroundLight min-h-screen flex flex-col desktop:items-center desktop:justify-center">
        <a href={routes.WORKSPACE_NAVIGATOR.root} className="block m-4 desktop:fixed top-0 left-0 h-[28px]">
          <LogoDesktopBlack />
        </a>
        <img src="/images/chill-guy.png" alt="logo" className="hidden lg:block fixed bottom-6 right-6 w-[260px]" />
        <div className="flex items-center justify-center px-4 pt-5 desktop:pt-0 desktop:px-0 w-full">
          <ShadowBox className="desktop:max-w-md py-8 px-6 w-full">
            <Outlet />
          </ShadowBox>
        </div>
      </div>
    </>
  );
}
